"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hero" className="relative w-full min-h-[80vh] md:min-h-[90vh] flex items-center justify-center bg-background overflow-hidden">
            {}
            <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/hero_forest_path.png')]" aria-hidden="true" />

            {}
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-black/10" aria-hidden="true" />

            {}
            <div ref={ref} className={`relative z-10 flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 text-center max-w-5xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                <h1 className="text-4xl font-light text-white tracking-tight leading-tight mb-4 uppercase !not-italic sm:text-5xl md:text-6xl lg:text-[4.75rem] sm:mb-6">TAI CHI CHUAN</h1>
                <p className="text-lg md:text-xl text-white/90 font-light tracking-widest mb-10 uppercase">DER KÖRPER WIE WASSER. DER GEIST WIE EIN BERG.</p>
                <Button asChild size="lg" className="uppercase tracking-[0.05em] font-normal rounded-md px-8 py-6 text-base">
                    
                </Button>
            </div>
        </section>;
}